import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowCurveLeftRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m15.086 19.8 5.314-5.314m0 0-5.314-5.314m5.314 5.314H7.6a4 4 0 0 1-4-4V4.2"
    />
  </svg>
);
export default SvgArrowCurveLeftRight;
